// // src/pages/AdminRooms.jsx
// import React, { useEffect, useState } from "react";
// import { db } from "../firebase";
// import { ref, onValue, push, set } from "firebase/database";

// export default function AdminRooms() {
//   const [name, setName] = useState("");
//   const [tables, setTables] = useState(10);
//   const [rooms, setRooms] = useState([]);

//   useEffect(() => {
//     const off = onValue(ref(db, "rooms"), (s) => {
//       const v = s.val() || {};
//       const arr = Object.keys(v).map(id => ({ id, ...v[id] }));
//       setRooms(arr);
//     });
//     return () => off();
//   }, []);

//   async function addRoom() {
//     if (!name.trim()) { alert("Enter room name"); return; }
//     const r = push(ref(db, "rooms"));
//     const tableMap = {};
//     const n = Math.max(1, Number(tables) || 1);
//     for (let i=1;i<=n;i++) tableMap[`T${i}`] = true;
//     await set(r, { name: name.trim(), createdAt: Date.now(), tables: tableMap });
//     setName(""); setTables(10);
//   }

//   return (
//     <div className="space-y-6">
//       <h1 className="text-2xl md:text-3xl font-bold">Admin — Rooms & Tables</h1>
//       <div className="bg-white rounded-2xl shadow p-6 space-y-4">
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
//           <input className="p-3 border rounded-xl" placeholder="Room Name (e.g., CSE-101)" value={name} onChange={(e)=>setName(e.target.value)} />
//           <input className="p-3 border rounded-xl" type="number" min="1" value={tables} onChange={(e)=>setTables(e.target.value)} />
//           <button onClick={addRoom} className="px-4 py-3 rounded-xl bg-black text-white hover:opacity-90">Add Room</button>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           {rooms.map(r => (
//             <div key={r.id} className="p-4 rounded-xl border bg-gray-50">
//               <div className="font-semibold">{r.name}</div>
//               <div className="text-sm text-gray-600">Tables: {r.tables ? Object.keys(r.tables).length : 0}</div>
//               <div className="mt-2 flex flex-wrap gap-2">
//                 {r.tables && Object.keys(r.tables).map(t => (
//                   <span key={t} className="px-2 py-1 rounded-lg bg-white border text-xs">{t}</span>
//                 ))}
//               </div>
//             </div>
//           ))}
//           {rooms.length === 0 && <div className="text-gray-500">No rooms yet.</div>}
//         </div>
//       </div>
//     </div>
//   );
// }

// src/pages/AdminRooms.jsx
import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { ref, push, onValue, set, remove, update } from "firebase/database";

function newTableMap(count) {
  const out = {};
  for (let i=1;i<=count;i++) out[String(i)] = { o: 0 }; // o=occupied (0/1). keep tiny
  return out;
}

export default function AdminRooms() {
  const [name, setName] = useState("");
  const [count, setCount] = useState(10);
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    const off = onValue(ref(db, "rooms"), (snap) => {
      const v = snap.val() || {};
      const rows = Object.entries(v).map(([id, r]) => ({ id, ...r }));
      setRooms(rows);
    });
    return () => off();
  }, []);

  async function addRoom() {
    if (!name || count < 1) return;
    await push(ref(db, "rooms"), { n: name, tc: count, t: newTableMap(count) }); // n=name, tc=table count, t=tables
    setName(""); setCount(10);
  }



  async function resetRoom(id, tc) {
    if (window.confirm("Reset all tables to available?")) {
      await update(ref(db, `rooms/${id}`), { t: newTableMap(tc) });
    }
  }

  async function delRoom(id) {
    if (window.confirm("Delete room?")) await remove(ref(db, `rooms/${id}`));
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl md:text-3xl font-bold">Admin — Rooms & Tables</h1>
      <div className="bg-white rounded-2xl shadow p-6 space-y-3">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          <input className="p-3 border rounded-xl" placeholder="Room name (e.g., A-101)" value={name} onChange={e=>setName(e.target.value)} />
          <input type="number" className="p-3 border rounded-xl" value={count} min="1" onChange={e=>setCount(parseInt(e.target.value||"1"))} />
          <button onClick={addRoom} className="px-4 py-3 rounded-xl bg-black text-white hover:opacity-90">Add Room</button>
        </div>

        <div className="grid gap-4">
          {rooms.map(r => (
            <div key={r.id} className="p-4 rounded-xl border">
              <div className="flex items-center justify-between">
                <div className="font-semibold">{r.n} <span className="text-gray-500">(Tables: {r.tc})</span></div>
                <div className="flex gap-2">
                  <button onClick={()=>resetRoom(r.id, r.tc)} className="px-3 py-1 rounded-lg border hover:bg-gray-50">Reset</button>
                  <button onClick={()=>delRoom(r.id)} className="px-3 py-1 rounded-lg border text-red-600 hover:bg-red-50">Delete</button>
                </div>
              </div>
              <div className="mt-3 flex flex-wrap gap-2">
                {r.t && Object.keys(r.t).map(k => (
                  <span key={k} className={`px-2 py-1 rounded text-xs border ${r.t[k]?.o ? "bg-red-100 text-red-700" : "bg-green-100 text-green-700"}`}>
                    Table {k}: {r.t[k]?.o ? "Taken" : "Free"}
                  </span>
                ))}
              </div>
            </div>
          ))}
          {rooms.length === 0 && <div className="text-gray-500">No rooms defined.</div>}
        </div>
      </div>
    </div>
  );
}
